import styled from 'styled-components';

export const WrapperTooltip = styled.div`
  background-color: #333;
  color: #fff;
  padding: 16px 16px 0 16px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 0px;
`;
